import { graphql, useStaticQuery } from 'gatsby';
export const useAboutUsPage = () => {
    const query = useStaticQuery(graphql `
      query useAboutUsQuery {
        cosmos {
          collections {
            photos {
              caption
              image {
                ticket
                fileName
              }
              order
            }
          }
          pages {
            page: about_us(dataKey: "page") {
              video_id
              video_caption
              page_top_copy {
                markdown
                image {
                  ticket
                  fileName
                }
              }
              team_text {
                team_header
                team_copy
              }
              product_toolkit {
                product_toolkit_header
                product_toolkit_copy
              }
              stack_text {
                stack_header
                stack_copy
              }
              brand_guide_text {
                brand_guide_name
                brand_guide_copy
                brand_guide_icon {
                  ticket
                  fileName
                }
              }
              section_icons {
                team_icon {
                  ticket
                  fileName
                }
                stack_icon {
                  ticket
                  fileName
                }
                product_toolkit_icon {
                  ticket
                  fileName
                }
              }
            }
          }
        }
      }
    `);
    return {
        page: query.cosmos.pages.page,
        photos: query.cosmos.collections.photos,
    };
};
export default useAboutUsPage;
